import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Selector = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Title = styled.span`
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: ${THEME.muiGrey};
  margin-bottom: 5px;
`;

export const Number = styled.span`
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 34px;
  color: ${THEME.bobBlack};
  margin-right: 8px;
`;

export const RemoveBagButton = styled(IconButton)`
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  margin-right: 0px !important;
  width: 60px;
  height: 24px;
  background-color: ${THEME.primary} !important;

  svg {
    fill: white;
    width: 18px;
  }
`;

export const AddBagButton = styled(IconButton)`
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  margin-left: 0px !important;
  width: 60px;
  height: 24px;
  background-color: ${THEME.primary} !important;

  svg {
    fill: white;
    width: 18px;
  }
`;
